import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import GrAvatar from "./GrAvatar";
import { gr } from "../tokens";

// Avatar with an "online" dot (chat lists, conversation header). Offline shows no dot.
export default function GrPresenceAvatar({
  src,
  name,
  size = "md",
  online = false,
  sx,
}) {
  return (
    <Box
      component="span"
      sx={{ position: "relative", display: "inline-flex", flex: "none", ...sx }}
    >
      <GrAvatar src={src} name={name} size={size} />
      {online ? (
        <Box
          component="span"
          aria-label="Online"
          role="img"
          sx={{
            position: "absolute",
            right: 0,
            bottom: 0,
            width: gr.space[3],
            height: gr.space[3],
            borderRadius: gr.radius.pill,
            background: gr.color.ok,
            border: `2px solid ${gr.color.surface}`,
          }}
        />
      ) : null}
    </Box>
  );
}

GrPresenceAvatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["sm", "md", "lg", "xl"]),
    PropTypes.number,
  ]),
  online: PropTypes.bool,
  sx: PropTypes.object,
};
